// import { useTranslation } from 'react-i18next'

import SubscriptionIcon from '@assets/subscription_icon.svg?react'

import { Btn } from '@shared/ui/btn'
import { CustomTippy } from '@shared/ui/customTippy'

import styles from './styles.module.scss'

//
//

export const SubscriptionBadge = ({ children, title }) => {
  // const { t } = useTranslation()

  //
  //

  return (
    <CustomTippy content={title}>
      <Btn design={['wrapper']}>
        <div className={styles['subscription-info']}>
          <div className={styles['subscription-info-icon']}>
            <SubscriptionIcon />
          </div>
          <span>{children}</span>
        </div>
      </Btn>
    </CustomTippy>
  )
}
